import { memo } from 'react';
import Head from 'next/head'; // Next.js
import HtmlStyleResources from './HtmlStyleResources';
import HtmlContent from './HtmlContent';
import ScriptExecutor from './ScriptExecutor';

function HtmlSection({
  payload,
  nonce,
  order,
  handleHtmlComplete,
}: {
  payload: {
    css: string;
    script: string;
    html: string;
  };
  nonce: string | undefined;
  order: number;
  handleHtmlComplete?: () => void;
}) {
  const cssUrls = Array.from(
    payload.css.matchAll(
      /<link[^>]*rel=["']stylesheet["'][^>]*href=["']([^"']+)["'][^>]*>/gi
    )
  ).map(m => m[1]);

  return (
    <>
      <Head>
        {cssUrls.map((url, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <link key={`preload-${i}`} rel="preload" as="style" href={url} />
        ))}
      </Head>

      <HtmlStyleResources cssPayload={payload.css} nonce={nonce} />
      <HtmlContent html={payload.html} />
      <ScriptExecutor
        script={payload.script}
        nonce={nonce}
        handleHtmlComplete={handleHtmlComplete}
      />
    </>
  );
}

export default memo(HtmlSection);
